export const DOCS_SITE_EVENT = {
  NAVIGATION_RIGHT_FUNCTION_AREA: 'apihub_button_click_navigate_right',
  DEBUG_BTN: 'apihub_button_click_debug',
  //todo
  DEBUG_SEND_BTN: 'apihub_button_click_send',
  FOOTER_GOTO_HOME: 'apihub_button_click_footer_goto_home',
  PAGE_VIEW: 'apihub_page_view',
  RUN_IN_APP: 'apihub_button_click_runinapp',
  //todo
  INPUT_CLICK_SEARCH: 'apihub_input_click_search',
  SWITCH_CLICK_BACKGROUND: 'apihub_switch_click_background',
  BUTTON_CLICK_EXPORT_DATA: 'apihub_button_click_export_data',
  BUTTON_CLICK_CLONE_DATA: 'apihub_button_click_clone_data',
} as const;

export type DocsSiteEventType = (typeof DOCS_SITE_EVENT)[keyof typeof DOCS_SITE_EVENT];

export type EventParams = Record<string, any>;

export interface BaseEventParams {
  page_title?: string;
}

export interface NavigationRightFunctionAreaParams extends BaseEventParams {
  title: string;
}

export type EventParamsMap = {
  apihub_button_click_navigate_right: NavigationRightFunctionAreaParams;
  apihub_button_click_debug: BaseEventParams;
  apihub_button_click_full_screen: BaseEventParams;
  apihub_button_click_send: BaseEventParams;
  apihub_button_click_footer_goto_home: BaseEventParams;
  apihub_page_view: BaseEventParams;
  apihub_button_click_runinapp: BaseEventParams;
  apihub_input_click_search: BaseEventParams;
  apihub_switch_click_background: BaseEventParams;
  apihub_button_click_export_data: BaseEventParams;
  apihub_button_click_clone_data: BaseEventParams;
  apihub_button_click_back_top: BaseEventParams;
  apihub_page_cache_diff: BaseEventParams;

  [key: string]: BaseEventParams;
};

export interface EventTrackingOptions {
  specificPlatform?: 'ga' | string;
}

export interface EventTracking {
  report: (eventName: string, eventParams?: EventParams, options?: EventTrackingOptions) => void;
  dataLayer: any[];
}

declare global {
  interface Window {
    eventTracking: EventTracking;
  }
}
